import type { Permission} from "@@/shared/auth/scopes/permission";
import { permissions } from "@@/shared/auth/scopes/permission";
import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import type { UserId} from "@@/shared/users/user-id";
import { userIdZodSchema } from "@@/shared/users/user-id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type { ProviderIdOrSlug} from "../provider";
import { providerIdOrSlugZodSchema } from "../provider";

type ProviderSetUserPermissionCommand = {
    readonly _id: string;
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly _type: "PROVIDER_SET_USER_PERMISSION_COMMAND";
    readonly userId: UserId;
    readonly providerIdOrSlug: ProviderIdOrSlug;
    readonly permission: Permission;
};

type FactoryParams = Except<
    ProviderSetUserPermissionCommand,
    "_id" | "_type" | "_createdAt"
>;

const providerSetUserPermissionCommandFactory = (params: FactoryParams) => {
    const initiateStripePaymentCommand: ProviderSetUserPermissionCommand = {
        ...params,
        _id: generateId({ prefix: "provider_set_user_permission_command__" }),
        _type: "PROVIDER_SET_USER_PERMISSION_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return initiateStripePaymentCommand;
};

const providerSetUserPermissionCommandZodSchema: z.ZodSchema<ProviderSetUserPermissionCommand> =
    z.object({
        _id: idZodSchema,
        _type: z.literal("PROVIDER_SET_USER_PERMISSION_COMMAND"),
        _createdAt: isoAndUnixZodSchema,
        userId: userIdZodSchema,
        providerIdOrSlug: providerIdOrSlugZodSchema,
        permission: z.enum(permissions),
    });

export {
    providerSetUserPermissionCommandFactory,
    providerSetUserPermissionCommandZodSchema,
};
export type { ProviderSetUserPermissionCommand };
